import React, {Component} from 'react';
import {compose} from "redux";
import {withRouter} from "react-router-dom";
import {withFirestore, firestoreConnect, isLoaded, isEmpty} from "react-redux-firebase";
import {connect} from "react-redux";
import {UserIsAuthenticated} from "../../utils/AuthManager";
import withSubscriptionValidatorHoc from "../../components/auth/SubscriptionValidatorHOC";
import {CALL_DB_PATH, COMPANY_DB_PATH} from "../../constants/DB_PATHS";
import withMyCoordsHOC from "../../components/MyCoordsHOC";
import {Table, Tag,} from 'antd';
import { CaretLeftOutlined, CaretRightOutlined} from "@ant-design/icons"
import {SERVICE_TYPES} from "../../constants/ServiceTypes";
import {DETAILED_CALL_URL} from "../../constants/URLS";
import moment from "moment";
import DistanceFromMe from "../../components/DistanceFromMe";
import CallHeader from "../../components/Headers/CallHeader";
import styled from "styled-components"
import {
    setPaginationStartAfter,
    setPaginationSteps
} from "../../redux/uxEnhance/action";
import { motion } from "framer-motion"
import {PRIMARY_COLOR, PRIMARY_GRAY, PRIMARY_TEXT_COLOR, SECONDARY_GRAY} from "../../constants/COLORS";


const columnSizes = {
    l: 'l',
    s: 's',
    xs: 'xs',
}
const largeScreenColumns = [

    {
        title: 'Szolgaltatas',
        key: 'service',
        render: (text, record, index) => {
            return <span key={text.id}>{SERVICE_TYPES[text.info[1].service].name}</span>
        },
        width: '15%',
    },
    {
        title: 'Cim',
        key: 'address',
        render: (text, record, index) => {
            return <span key={text.id}>{text.info[0].address.formatted_address}</span>
        },
        width: '20%',
    },
    {
        title: 'Tavolsag',
        key: 'distance',
        render: (text, record, index) => {
            return <DistanceFromMe lat={text.info[0].lat} lng={text.info[0].lng}/>
        },
        width: '12%',
    },
    {
        title: 'Relative Ido',
        key: 'date',
        render: (text, record, index) => {
            return <div>{moment(new Date(text.callDate.seconds * 1000), "YYYYMMDD").fromNow()}</div>
        },
        width: '15%',
    },
    {
        title: 'Idopont',
        key: 'date',
        render: (text, record, index) => {
            return <div style={{textAlign: 'center'}}>
                {moment(new Date(text.callDate.seconds * 1000)).format("HH:mm")}
                <br/>
                {moment(new Date(text.callDate.seconds * 1000)).format("YYYY.MM.DD.")}
            </div>
        },
        width: '15%',
    },
    {
        title: 'Statusz',
        key: 'status',
        render: (text, record, index) => {
            return (<div>
                {text.taken ?
                    <Tag color={'green'}>Megerositett</Tag>
                    :
                    <Tag color={'volcano'}>Varakozik</Tag>
                }
            </div>)
        },
        width: '10%',
    },
    {
        title: 'Mentes',
        key: 'call',
        render: (text, record, index) => {
            return (<div>
                {text.active ?
                    <Tag color={'blue'}>Aktiv</Tag>
                    :
                    <Tag>Inaktiv</Tag>
                }
            </div>)
        },
        width: '15%',
    },
];
const smallScreenColumns = [

    {
        title: 'Szolg',
        key: 'service',
        render: (text, record, index) => {
            return <span key={text.id}>{SERVICE_TYPES[text.info[1].service].name}</span>
        },
        width: '10%',
    },
    {
        title: 'Tav',
        key: 'distance',
        render: (text, record, index) => {
            return <DistanceFromMe lat={text.info[0].lat} lng={text.info[0].lng}/>
        },
        width: '10%',
    },
    {
        title: 'Rel Ido',
        key: 'date',
        render: (text, record, index) => {
            return <div>{moment(new Date(text.callDate.seconds * 1000), "YYYYMMDD").fromNow()}</div>
        },
        width: '20%',
    },
    {
        title: 'Statusz',
        key: 'status',
        render: (text, record, index) => {
            return (<div>
                {text.taken ?
                    <Tag color={'green'}>Megerositett</Tag>
                    :
                    <Tag color={'volcano'}>Varakozik</Tag>
                }
            </div>)
        },
        width: '10%',
    },
    {
        title: 'Mentes',
        key: 'call',
        render: (text, record, index) => {
            return (<div>
                {text.active ?
                    <Tag color={'blue'}>Aktiv</Tag>
                    :
                    <Tag>Inaktiv</Tag>
                }
            </div>)
        },
        width: '10%',
    },
];
const xsmallScreenColumns = [

    {
        title: 'Szolg',
        key: 'service',
        render: (text, record, index) => {
            return <span key={text.id}>{SERVICE_TYPES[text.info[1].service].name}</span>
        },
        width: '10%',
    },
    {
        title: 'Tav',
        key: 'distance',
        render: (text, record, index) => {
            return <DistanceFromMe lat={text.info[0].lat} lng={text.info[0].lng}/>
        },
        width: '10%',
    },
    {
        title: 'Rel Ido',
        key: 'date',
        render: (text, record, index) => {
            return <div>{moment(new Date(text.callDate.seconds * 1000), "YYYYMMDD").fromNow()}</div>
        },
        width: '20%',
    },
    {
        title: 'Statusz',
        key: 'status',
        render: (text, record, index) => {
            return (<div>
                {text.taken ?
                    <Tag color={'green'}>Megerositett</Tag>
                    :
                    <Tag color={'volcano'}>Varakozik</Tag>
                }
            </div>)
        },
        width: '10%',
    },
];
const TableContainer = styled.div`
width: 80%;
max-height: calc(80vh - 60px);
min-height: 20vh;
display: block;
overflow-x: auto;
margin: 0 auto;
//box-shadow: 5px 5px 15px 5px rgba(0, 0, 0, 0.15);

@media only screen and (max-width: 1500px){
width: 100%;
}
@media only screen and (max-width: 800px){
max-height: 75vh;
}

@media only screen and (max-width: 600px){
padding-top: 5rem;
max-height: 85vh;

}



.ant-table{
  &-header{
    top: -2px !important;
    table{
      border-radius: 0 !important;
    }
  }
  
  thead{
    th{
      border-radius: 0 !important;
      background-color: ${PRIMARY_COLOR};
      border: 2px solid ${PRIMARY_COLOR};
      color: ${PRIMARY_TEXT_COLOR};
    }
  }
  &-row{
    cursor: pointer;
    overflow-x: hidden;
  }
  &-cell{
    font-family: Quicksand, sans-serif;
    font-weight: 600;
    font-size: 1rem;
    text-align: center;
    
    @media only screen and (max-width: 525px){
      font-size: 0.8rem;
      padding: 25px 10px;
    }

  }
}
`
const PaginationBtn = styled(motion.button)` 
background: none;
border: none;
outline: none ;
position: fixed;
  bottom: 5vh;
  &.prev{
      right: calc(50% - 100px);

  }
  &.next{
      right: calc(50% - 300px);
  }
  @media only screen and (max-width: 1250px){
      bottom: 2rem;
      &.prev{
          right: calc(50% + 100px);
    
      }
      &.next{
          right: calc(50% - 100px);
      }
  }
`
const initialState = {
    pageIndexes: [],
    currentPage: 0,
    firstPage: true,
    lastPage: false,
    lastPageNum: 0,
    columnSize: columnSizes.s,
    columns: smallScreenColumns,
}
class BasicTablePage extends Component {
    constructor() {
        super();
        this.state = initialState
    }
    handleResize = () => {
        let { innerWidth: width} = window;
        if(width >= 800 && !(this.state.columnSize === columnSizes.l)){
            this.setState({
                columnSize: columnSizes.l,
                columns: largeScreenColumns
            })
        }
        if(width < 800 && !(this.state.columnSize === columnSizes.s)){
            this.setState({
                columnSize: columnSizes.s,
                columns: smallScreenColumns
            })
        }
        if(width < 550 && !(this.state.columnSize === columnSizes.xs)){
            this.setState({
                columnSize: columnSizes.xs,
                columns: xsmallScreenColumns
            })
        }
    }
    componentDidMount(){
        this.handleResize()
        window.addEventListener('resize', this.handleResize)

    }
    componentWillUnmount() {
        this.props.setPaginationStartAfter(null)
        window.removeEventListener('resize', this.handleResize)
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        this.checkIfLastPage(prevProps.calls)
    }
    loadNextPage = () => {
        const {calls} = this.props
        if(calls && calls.length < this.props.paginationSteps){
            this.setState({
                lastPage: true
            })
        } else {
            let lastDoc = calls[calls.length - 1]
            let newPageIndexes = this.state.pageIndexes.concat(lastDoc.callDate)
            this.setState({
                pageIndexes: newPageIndexes,
                currentPage: this.state.currentPage + 1,
                firstPage: false
            })
            this.props.setPaginationStartAfter(lastDoc.callDate)
        }



    }
    loadPrevPage = () => {
        let prevPageIndex= this.state.currentPage - 2
        if(prevPageIndex < 0){
            this.props.setPaginationStartAfter(null)
            this.setState({
                pageIndexes: [],
                currentPage: 0,
                firstPage: true,
                lastPage: false,
            })

        } else {
            this.props.setPaginationStartAfter(this.state.pageIndexes[prevPageIndex])
            let newPageIndexes = this.state.pageIndexes
            newPageIndexes.pop()
            this.setState({
                pageIndexes: newPageIndexes,
                currentPage: this.state.currentPage - 1,
                lastPage: false,
            })
        }
    }
    checkIfLastPage = (prevCalls, prevState) => {


        if(
            prevCalls !== this.props.calls &&
           // prevState !== this.state &&
            !this.state.lastPage &&
           // !this.state.firstPage &&
            isLoaded(this.props.calls) &&
            this.props.calls.length < this.props.paginationSteps
        ){
            this.setState({lastPage: true})
        }
    }
    render() {
        if(!this.props.queryWhere){
            console.error('No queryWhere given')
            return null
        }
        if(!this.props.header){
            console.error('No title given')
            return null
        }
        return (
            <div style={{maxHeight: '100vh', boxSizing: 'border-box', overflow: 'hidden'}}>

                <CallHeader listView={true}>{this.props.header}</CallHeader>

                <TableContainer>
                    <Table columns={this.state.columns}
                           rowKey={record => record.id}
                           dataSource={this.props.calls}
                           pagination={false}
                           sticky
                        //loading={isLoaded(this.props.calls)}
                        //onChange={this.handleTableChange}
                           onRow={(record, rowIndex) => {
                               return {
                                   onClick: event => {
                                       this.props.history.push(DETAILED_CALL_URL + record.id)
                                   },

                               };
                           }}
                    />
                </TableContainer>

                <PaginationBtn
                    onClick={this.loadPrevPage}
                    className={'prev'}
                    style={{scale: 3}}
                    whileHover={{ scale: 4 }}
                    whileTap={{ scale: 3.5 }}
                    disabled={this.state.firstPage}
                >
                    <CaretLeftOutlined style={{color: this.state.firstPage ? SECONDARY_GRAY : PRIMARY_GRAY }}/>
                </PaginationBtn>
                <PaginationBtn
                    onClick={this.loadNextPage}
                    className={'next'}
                    style={{scale: 3}}
                    whileHover={{ scale: 4 }}
                    whileTap={{ scale: 3.5 }}
                    disabled={this.state.lastPage}

                >
                    <CaretRightOutlined style={{color: this.state.lastPage ? SECONDARY_GRAY : PRIMARY_GRAY}}/>
                </PaginationBtn>

            </div>
        );
    }
}
const mapStateToProps = state => {
    return {
        pagination: state.uxEnhance.pagination,
        paginationSteps: state.uxEnhance.paginationSteps,
        paginationStartAfter: state.uxEnhance.paginationStartAfter,
    }
}
const mapDispatchToProps = dispatch => {
    return {
        setPaginationSteps: (paginationSteps) =>
            dispatch(setPaginationSteps(paginationSteps)),
        setPaginationStartAfter: (paginationStartAfter) =>
            dispatch(setPaginationStartAfter(paginationStartAfter)),

    }
}
export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    withRouter,
    withFirestore,
    connect(
        ({firebase: {auth, profile}}) => ({
            auth,
            profile
        })
    ),
    UserIsAuthenticated,
    connect((state, props) => ({
        calls: state.firestore.ordered.excCalls
    })),
    firestoreConnect((props) => {
        return [{
            collection: CALL_DB_PATH,
            where: props.queryWhere || null,
            orderBy: [
                ['callDate', 'desc'],
            ],
            startAfter: props.paginationStartAfter,
            limit: props.paginationSteps,

            storeAs: 'excCalls'
        }]
    }),
    withSubscriptionValidatorHoc,
    withMyCoordsHOC,
)(BasicTablePage);